import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { SingleAssignmentFragment } from '../../../generated/graphql_offer';
import { SPACING_REGULAR } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import _DeliverableDetail, { Props as DeliverableDetailProps } from './DeliverableDetail';

interface Props extends DeliverableDetailProps {
  assignment: SingleAssignmentFragment | null;
  modificationRequestApprovable: boolean;
  selectedItemCanDownloadOrUpload: boolean;
  onClickApproveModificationRequestButton: () => void;
  isPastDeliverable?: boolean;
  className?: string;
  profileUrl: string;
}

const DeliverableDetailCard = ({
  creation,
  deliverable,
  onClickDownloadButton,
  onClickSendButton,
  modificationRequestApprovable,
  onClickApproveModificationRequestButton,
  className,
  profileUrl,
}: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root className={className}>
      {deliverable ? (
        <DeliverableDetail
          creation={creation}
          deliverable={deliverable}
          modificationRequestApprovable={modificationRequestApprovable}
          onClickDownloadButton={onClickDownloadButton}
          onClickSendButton={onClickSendButton}
          onClickApproveModificationRequestButton={onClickApproveModificationRequestButton}
          profileUrl={profileUrl}
        />
      ) : null}
    </Root>
  );
};

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['1fr'],
    rows: ['auto', 'auto', 'auto', 'auto'],
    areas: [['reviewForm'], ['deliverableDetail'], ['reputationDetail'], ['modificationRequestDetail']],
  }),
);

const DeliverableDetail = styled(_DeliverableDetail)(gridLayoutItem('deliverableDetail'), {
  padding: SPACING_REGULAR,
});

export default DeliverableDetailCard;
